// SingleQuestion.jsx
import React, { useState } from "react";
import { BsPlus } from "react-icons/bs";
import { FaMinus } from "react-icons/fa";

export default function SingleQuestion({ question, answer }) {
  const [showAnswer, setShowAnswer] = useState(false);
  
  const toggleAnswer = () => setShowAnswer(!showAnswer);
  
  return (
    <div className="border rounded-md overflow-hidden">
      <div 
        onClick={toggleAnswer}
        className="flex items-center justify-between p-3 sm:p-4 cursor-pointer hover:bg-gray-50 transition-colors duration-200"
      >
        <h2 className="text-base sm:text-lg font-semibold tracking-wide pr-2">
          {question}
        </h2>
        <button 
          className="text-green-700 hover:text-green-800 flex-shrink-0"
          aria-label={showAnswer ? "Hide answer" : "Show answer"}
        >
          {showAnswer ? <FaMinus /> : <BsPlus className="text-xl" />}
        </button>
      </div>
      
      {showAnswer && (
        <div 
          className="p-3 sm:p-4 text-sm sm:text-base text-gray-800 bg-gray-50 border-t"
        >
          {answer}
        </div>
      )}
    </div>
  );
}